import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subscription, debounceTime, fromEvent, throttleTime } from 'rxjs';
import { destructSubscriptionArray } from 'src/app/core/ui-helpers/functions/destruct-subscription-array';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() label: string;
  labelToggle = false;
  @Input() stepsCompleted: number;
  @Input() stepsTotal: number;
  completed = false;
  @ViewChild('outerRef', { static: true }) outerRef: ElementRef;
  @ViewChild('innerRef', { static: true }) innerRef: ElementRef;
  @ViewChild('labelRef', { static: true }) labelRef: ElementRef;
  subscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.completed = this.stepsCompleted === this.stepsTotal;
  }

  ngAfterViewInit() {
    this.resizeInnerBar();
    this.centerLabel();
    this.subscriptions.push(
      fromEvent(window, 'resize')
        .pipe(throttleTime(200), debounceTime(200))
        .subscribe(() => {
          this.resizeInnerBar();
          this.centerLabel();
        })
    );
    this.setHoverEvents();
  }

  ngOnDestroy(): void {
    destructSubscriptionArray(this.subscriptions);
  }

  resizeInnerBar() {
    if (!this.outerRef || !this.innerRef) return;
    const innerBarRatio = this.stepsCompleted / this.stepsTotal;
    const outerWidth = this.outerRef.nativeElement.offsetWidth;
    this.innerRef.nativeElement.style.width = `${outerWidth * innerBarRatio}px`;
  }

  centerLabel() {
    if (!this.outerRef || !this.labelRef) return;
    const outerWidth = this.outerRef.nativeElement.offsetWidth;
    const labelWidth = this.labelRef.nativeElement.offsetWidth;
    this.labelRef.nativeElement.style.left = `${
      outerWidth / 2 - labelWidth / 2
    }px`;
  }

  setHoverEvents() {
    if (!this.outerRef) return;
    this.subscriptions.push(
      fromEvent(this.outerRef.nativeElement, 'mouseover')
        .pipe(throttleTime(200), debounceTime(200))
        .subscribe(() => {
          this.labelToggle = true;
        })
    );

    this.subscriptions.push(
      fromEvent(this.outerRef.nativeElement, 'mouseout')
        .pipe(throttleTime(200), debounceTime(200))
        .subscribe(() => {
          this.labelToggle = false;
        })
    );

    if (!this.innerRef) return;
    this.subscriptions.push(
      fromEvent(this.innerRef.nativeElement, 'mouseover')
        .pipe(throttleTime(200), debounceTime(200))
        .subscribe(() => {
          this.labelToggle = true;
        })
    );

    this.subscriptions.push(
      fromEvent(this.innerRef.nativeElement, 'mouseout')
        .pipe(throttleTime(200), debounceTime(200))
        .subscribe(() => {
          this.labelToggle = false;
        })
    );
  }
}
